module.exports = __webpack_public_path__ + "static/summer-accessories.0cf06387.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/Nav/summer-accessories.png
// module id = 1142
// module chunks = 231608221292675